const CSS_VALID_UNITS = {
  CM: "cm",
  MM: "mm",
  Q: "Q",
  IN: "in",
  PC: "pc",
  PT: "pt",
  PX: "px",
  REM: "rem"
};
export {
  CSS_VALID_UNITS
};
//# sourceMappingURL=constants.mjs.map
